import styled from 'styled-components';
import { XIShadowsDown } from '@inmoment/the-kitchen';
interface TileWrapperProps {
  size: number;
  stretch?: boolean;
  flexDirection?: 'column' | 'row';
  justifyContent?: 'flex-start' | 'center' | 'flex-end';
  alignItems?: 'flex-start' | 'center' | 'flex-end';
}
export const TileWrapper = styled.span`
  box-sizing: border-box;
  background: white;
  height: ${(props: TileWrapperProps) => (props.stretch ? 'auto' : `${props.size}px`)};
  width: ${(props: TileWrapperProps) => (props.stretch ? 'auto' : `${props.size}px`)};
  border: 1px solid lightgray;
  display: flex;
  flex-direction: ${(props: TileWrapperProps) => props.flexDirection};
  justify-content: ${(props: TileWrapperProps) => props.justifyContent};
  align-items: ${(props: TileWrapperProps) => props.alignItems};
  padding: 6px 12px;
  transition: all 0.1s ease-in-out;
  &:hover {
    border-radius: 6px;
    transform: scale(1.1);
    z-index: 10;
    box-shadow: ${XIShadowsDown[3]};
  }
`;
